<template>
  <b-modal id="updateCarUserDataModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmcaruserdata.updateCarUserDataModalHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="assignation">
      <b-col>
        <EXCMCarUserDataUpdate :assignationId="assignation['@id']"></EXCMCarUserDataUpdate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMCarUserDataUpdate from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'CreateCarUserDataModal',
  components: {
    EXCMCarUserDataUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.userdata.assignCarUpdate.show
    },
    servicemanObject () {
      return this.$store.state.modals.userdata.assignCarUpdate.serviceman
    },
    assignationObject () {
      return this.$store.state.modals.userdata.assignCarUpdate.assignation
    },
    close () {
      return this.$store.state.modals.userdata.assignCarUpdate.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'servicemanObject': function (val) {
      this.openModal()
    },
    'assignationObject': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      serviceman: null,
      assignation: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.servicemanObject && this.assignationObject) {
        this.serviceman = Object.assign({}, this.servicemanObject)
        this.assignation = Object.assign({}, this.assignationObject)
        this.$store.state.modals.userdata.assignCarUpdate.show = 0
        this.$store.state.modals.userdata.assignCarUpdate.serviceman = null
        this.$store.state.modals.userdata.assignCarUpdate.assignation = null
        this.$bvModal.show('updateCarUserDataModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdata.assignCarUpdate.close = 0
        this.$bvModal.hide('updateCarUserDataModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
